import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '../../theme/theme';

export class StatisticsBar extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      color: PropTypes.string,
      onClick: PropTypes.func,
      highlight: PropTypes.bool,
    })).isRequired,
    compact: PropTypes.bool,
  };

  render() {
    const { data, compact } = this.props;

    return (
      <div
        className="grid gap-3"
        style={{ gridTemplateColumns: `repeat(${data.length}, minmax(0, 1fr))` }}
      >
        {data.map((statItem, i) => (
          <div
            key={i}
            onClick={() => (statItem.onClick ? statItem.onClick(statItem) : null)}
            className={[
              'rounded-md border border-gray-100 bg-gray-50 px-3 py-4 text-center transition-colors',
              statItem.onClick ? 'cursor-pointer hover:border-gray-200 hover:bg-white' : '',
              statItem.highlight ? 'border-blue-100 bg-blue-50' : '',
            ].join(' ')}
          >
            <div
              className={`font-semibold tabular-nums ${compact ? 'text-2xl' : 'text-3xl'}`}
              style={{ color: statItem.color || Theme.PRIMARY_COLOR }}
            >
              {statItem.value}
            </div>
            <div className="mt-1 text-xs font-medium uppercase tracking-wide text-gray-500">
              {statItem.name}
            </div>
          </div>
        ))}
      </div>
    );
  }
}
